export default __webpack_public_path__ + "static/media/FileZilla.328f1871.svg";